/** Interfaces */
import { DsMainMenuLogsInterface } from '../interfaces/ds-main-menu-logs.interface';

export class DsMainMenuLogos {
  /**
   * The expanded menu logo.
   */
  expanded?: string;

  /**
   * The reduced menu logo.
   */
  reduced?: string;

  /**
   * Creates an instance of DsMainMenuLogos.
   *
   * @param logos Given logs urls
   */
  constructor(logos: DsMainMenuLogsInterface) {
    this.expanded = logos.expanded;
    this.reduced = logos.reduced;
  }
}
